import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { SectionDivider } from './ui/SectionDivider';
import { CloudRain, Layers, Fingerprint } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 md:py-32 bg-cream-50 relative" data-id="element-270">
      <SectionDivider variant="wave" position="top" color="#F3EDE4" className="absolute top-0 left-0 w-full" data-id="element-271" />

      <div className="max-w-5xl mx-auto px-6 pt-12" data-id="element-272">
        <div className="grid md:grid-cols-2 gap-12 items-center mb-16" data-id="element-273">
          <FadeIn data-id="element-274">
            <h2 className="text-3xl md:text-5xl font-serif text-brown-900 leading-tight" data-id="element-275">
              El problema real: <br data-id="element-276" />
              <span className="text-terracotta italic" data-id="element-277">
                estás mezclando piezas sin mapa
              </span>
            </h2>
          </FadeIn>

          <FadeIn delay={0.2} className="text-lg text-brown-800/80 space-y-4" data-id="element-278">
            <p data-id="element-279">
              Las rutinas de redes sociales no están diseñadas para ti. Están
              diseñadas para:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-2" data-id="element-280">
              <li data-id="element-281">verse bien en 30 segundos</li>
              <li data-id="element-282">ser copiadas por miles de personas</li>
              <li data-id="element-283">y hacerte sentir que si no te funciona, es tu culpa</li>
            </ul>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} className="text-center mb-12" data-id="element-284">
          <p className="text-xl md:text-2xl font-serif text-brown-900" data-id="element-285">
            Pero el pelo no funciona así. Tu pelo responde a{' '}
            <span className="underline decoration-terracotta decoration-2 underline-offset-4" data-id="element-286">
              tres cosas
            </span>
            :
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-287">
          {[{
          icon: Fingerprint,
          title: 'Tu Tipo',
          desc: '1A – 4C',
          delay: 0.4
        }, {
          icon: Layers,
          title: 'Tus Capas',
          desc: 'Qué va primero y qué va después',
          delay: 0.5
        }, {
          icon: CloudRain,
          title: 'Tu Clima',
          desc: 'La humedad que cambia todo',
          delay: 0.6
        }].map((item, i) => <FadeIn key={i} delay={item.delay} className="h-full" data-id="element-288">
              <div className="bg-white p-8 rounded-2xl shadow-sm border border-brown-900/5 h-full flex flex-col items-center text-center hover:shadow-md transition-shadow duration-300" data-id="element-289">
                <div className="w-16 h-16 rounded-full bg-cream-100 flex items-center justify-center mb-6 text-terracotta" data-id="element-290">
                  <item.icon className="w-8 h-8" data-id="element-291" />
                </div>
                <h3 className="text-xl font-serif font-bold text-brown-900 mb-2" data-id="element-292">
                  {item.title}
                </h3>
                <p className="text-brown-800/80" data-id="element-293">{item.desc}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.7} className="text-center" data-id="element-294">
          <p className="text-2xl md:text-3xl font-serif italic text-brown-900 max-w-3xl mx-auto leading-relaxed" data-id="element-295">
            "Cuando una de esas tres falla, no importa cuánto compres. Vas a
            seguir en el ciclo."
          </p>
        </FadeIn>
      </div>
    </section>;
}